import { tailwind } from '@theme-ui/presets'

export default {
  ...tailwind,
  colors: {
    ...tailwind.colors,
    primary: '#002855',
    primaryHover: '#005EB8',
    secondary: '#EAAA00',
    secondaryHover: '#ED8B00',
    black: '#2C2A29',
    accent: [
      '#0033A0',
      '#9BD3DD',
      '#005EB8',
      '#0D5257',
      '#9ABEAA',
      '#ED8B00',
      '#BE3A34',
      '#CD4C08',
      '#FDDA24',
      '#657A68',
    ],
    warmgray: ['#BFB8AF', '#7C736A', '#BFB8AF'],
  },
  fonts: {
    body: `Roboto, -apple-system, BlinkMacSystemFont,"Segoe UI",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"`,
    heading: `"EB Garamond", "Times New Roman", Times, Georgia, Cambria,  serif`,
  },
  sizes: {
    ...tailwind.sizes,
    container: '1024px',
  },
  buttons: {
    ...tailwind.buttons,
    primary: {
      ...tailwind.buttons.simple,
      bg: 'primary',
      textTransform: 'uppercase',
      fontSize: 0,
      letterSpacing: '1px',
      transition: 'all .15s ease',
      '&:hover': {
        bg: 'primaryHover',
      },
    },
    secondary: {
      ...tailwind.buttons.simple,
      bg: 'secondary',
      textTransform: 'uppercase',
      fontSize: 0,
      letterSpacing: '1px',
      transition: 'all .15s ease',
      '&:hover': {
        bg: 'secondaryHover',
      },
    },
    outline: {
      ...tailwind.buttons.outline,
      textTransform: 'uppercase',
      fontSize: 0,
      letterSpacing: '1px',
      transition: 'all .15s ease',
    },
    inverted: {
      ...tailwind.buttons.outline,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'white',
      color: 'white',
      bg: 'transparent',
      textTransform: 'uppercase',
      fontSize: 0,
      letterSpacing: '1px',
      transition: 'all .15s ease',
      '&:hover': {
        bg: 'primaryHover',
        color: 'white',
      },
    },
  },
  cards: {
    ...tailwind.cards,
    stacked: {
      boxShadow: 'lg',
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      width: ['full', 'full', '1/3'],
      bg: 'white',
      my: 3,
    },
    wide: {
      boxShadow: 'lg',
      display: 'flex',
      flexWrap: 'wrap',
      width: ['full', '4/5'],
      bg: 'white',
      my: 3,
      '&:nth-of-type(2n)': {
        flexDirection: 'row-reverse',
      },
    },
    full: {
      display: 'flex',
      flexWrap: 'wrap',
      width: ['full'],
      bg: 'gray.5',
      color: 'white',
    },
  },
  styles: {
    ...tailwind.styles,
    h1: {
      ...tailwind.styles.h1,
      color: `heading`,
      fontWeight: 'normal',
      fontSize: [5, 6],
      m: 0,
    },
    h2: {
      ...tailwind.styles.h2,
      color: `heading`,
      fontSize: [3, 3, 4],
      fontWeight: 'normal',
      mt: 2,
    },
    h3: {
      ...tailwind.styles.h4,
      color: `heading`,
      fontSize: [2, 2, 3],
      fontWeight: 'normal',
      mt: 2,
    },
    h4: {
      ...tailwind.styles.h5,
      color: `heading`,
      fontSize: [1, 1, 2],
      mt: 2,
    },
    h5: {
      ...tailwind.styles.h5,
      color: `heading`,
      fontSize: [1, 1, 2],
      fontWeight: 'normal',
      mt: 2,
    },
    p: {
      fontFamily: `body`,
      fontSize: [1],
      fontWeight: `normal`,
      lineHeight: `body`,
      '--baseline-multiplier': 0.179,
      '--x-height-multiplier': 0.35,
    },
    ul: {
      li: {
        fontFamily: `body`,
        fontSize: [1],
        fontWeight: 'normal',
        letterSpacing: `-0.003em`,
        lineHeight: `body`,
        '--baseline-multiplier': 0.179,
        '--x-height-multiplier': 0.35,
      },
    },
    ol: {
      li: {
        fontFamily: ['Roboto', 'sans-serif'].join(','),
        fontSize: [1, 1, 2],
        letterSpacing: `-0.003em`,
        lineHeight: `body`,
        '--baseline-multiplier': 0.179,
        '--x-height-multiplier': 0.35,
      },
    },
    footerLinks: {
      listStyle: 'none',
      margin: '0 0 2rem 0',
      padding: 0,
      li: {
        marginBottom: `calc(1.45rem / 2.5)`,
      },
      'li a': {
        color: 'text',
        textDecoration: 'none',
      },
      'li a:hover': {
        textDecoration: 'underline',
      },
    },
    listReset: {
      listStyle: 'none',
      margin: 0,
    },

    twoCols: {
      columnCount: [1, 1, 2],
      columnGap: [0, 0, 5],
    },
  },
}
